import React from 'react'

const UndoIcon = ({color = 'currentColor', width = 20, height = 20, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M4.99996 8.33333H13.3333C15.1743 8.33333 16.6666 9.82572 16.6666 11.6667C16.6666 13.5076 15.1743 15 13.3333 15H9.99996"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.49996 11.6667L4.16663 8.33333L7.49996 5"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default UndoIcon
